import $ from 'jquery';
//import utils from '../Libraries/Utils';
//console.log('is touch:', utils.isTouchDevice());

const $page = $('.page');
const $overlay = $('.page-header__overlay');

$('.nav-toggle').on('click', function () {
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'nav--visible';
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.nav').removeClass(navActiveClass);
    } else {
        $(this).addClass(toggleActiveClass);
        $('.nav').addClass(navActiveClass);
    }
});


$('.nav__toggle').on('click', function () {
    $(this).siblings('.nav__list').toggleClass('nav__list--visible');
    $(this).toggleClass('nav__toggle--open');
})

// simple method to prevent click on touch devices (on first touch)
let mouseOverTimestamp = 0;
$('.nav__link--level1').on('mouseover', ev => {
    mouseOverTimestamp = ev.timeStamp;
}).on('click', ev => {
    if (ev.timeStamp - mouseOverTimestamp < 50) {
        ev.preventDefault();
    }
});


const $navsLevel2 = $('.nav__list--level2');
const $pagesLevel1 = $('.nav__page--level1');

function navListUpdater() {
    let width = $(window).width();

    $navsLevel2.each((i, elem) => {
        if (window.getComputedStyle(elem).display === 'none') {
            return;
        }
        const $elem = $(elem);
        let right = $elem.offset().left + $elem.outerWidth();
        if (right > width && !elem.classList.contains('nav__list--right')) {
            elem.classList.add('nav__list--right');
        }
    });

    (() => {
        if ($overlay.length === 0) {
            return;
        }

        const pageOffsetLeft = $page.offset().left;
        $pagesLevel1.each((i, elem) => {
            const $elem = $(elem);
            let offsetLeft = $elem.offset().left - pageOffsetLeft;
            elem.style.setProperty('--subnav-offset-left', offsetLeft.toString());
            elem.style.setProperty('--overlay-width', $overlay.width().toString());
            elem.style.setProperty('--overlay-height', ($overlay.height() - 20).toString());
        });
    })();

    window.requestAnimationFrame(navListUpdater);
}

window.requestAnimationFrame(navListUpdater);


const updater = () => {
    Array.from(document.querySelectorAll('.nav__list--level2')).forEach(elem => {
        if (elem.offsetWidth > 0) {
            elem.parentNode.style.setProperty('--nav2-width', elem.offsetWidth);
        }
    });
    window.requestAnimationFrame(updater);
};

window.requestAnimationFrame(updater);


/*
 Menü dritte Ebene
 */
$('.nav__link--level2').on('click', ev => {
    //ev.preventDefault();
});
